import errorTypeService from '@/lib/services/errorTypeService'
import { CommercialAgreementDirectionInput } from '@/redux/slices/commercialAgreementsForm'
import { NonNullableAxiosError } from '@/types/misc'

class AddPanelService {
  isValidationError(error: unknown): error is AddPanelValidationError {
    if (!errorTypeService.isUnprocessibleEntityError(error)) {
      return false
    }

    const responseData = error.response?.data

    return (
      typeof responseData === 'object' &&
      responseData !== null &&
      'errors' in responseData
    )
  }

  isPanelRelatedError(error: unknown): error is PanelValidationError {
    if (!this.isValidationError(error)) {
      return false
    }

    return !!error.response.data.errors.panel
  }
}

type AddPanelValidationError = NonNullableAxiosError<{
  errors: {
    panel?: string
    outgoingAgreement: Record<keyof CommercialAgreementDirectionInput, string>
    incomingAgreement: Record<keyof CommercialAgreementDirectionInput, string>
  }
}>

type PanelValidationError = NonNullableAxiosError<{
  errors: {
    panel: string
    outgoingAgreement: Record<keyof CommercialAgreementDirectionInput, string>
    incomingAgreement: Record<keyof CommercialAgreementDirectionInput, string>
  }
}>

const addPanelService = new AddPanelService()

export default addPanelService
